/**
 * @fileoverview Page module events.
 */

import { EVENT_PREFIX } from "../../core/events";

/**
 * Page navigation events.
 */
export const PAGE_EVENTS = {
  /** Navigate using React Router (SPA navigation) */
  NAVIGATE: `${EVENT_PREFIX}page.navigate`,
  /** Redirect using window.location (full page reload) */
  REDIRECT: `${EVENT_PREFIX}page.redirect`,
  /** Set page title */
  SET_TITLE: `${EVENT_PREFIX}page.setTitle`,
} as const;
